import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  FARHistoryIcon,
  deleteIcon,
  tableEditIcon,
} from "../../../assets/images";
import { formateDateTime } from "../../../utils/commonFunctions";

import { PDFDownloadLink } from "@react-pdf/renderer";
import MadePdf from "./MadePdf";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import { CircularAvatar } from "../../commons";
import {  FixedAssetUsersHistoryData } from "../../../redux/fixedAsset/fixedAssetRegisterTypes";
type AppProps = {
  finacAssetListing: [];
  history: any;
  clientCode: number;
  tableHeader: [] | TableHeadersType[];
  handleConfirmationModal: () => void;
  handleDeleteData: (data: any) => void;
  handleHistoryFixedAssetModule: (data: any) => void;
  persistData: any;
  isEditFixedAssetPresent: boolean;
  isDeleteFixedAssetPresent: boolean;
  handleShowAssetUser: (data: any) => void;
  fixedAssetUsersHistoryData: FixedAssetUsersHistoryData[] | [];
  assetHistoryFetching?:boolean;
  handleRemoveData:()=>void;
};

const FixedAssetTableData = ({
  finacAssetListing,
  tableHeader,
  history,
  clientCode,
  handleConfirmationModal,
  handleDeleteData,
  persistData,
  handleHistoryFixedAssetModule,
  isEditFixedAssetPresent,
  isDeleteFixedAssetPresent,
  handleShowAssetUser,
  fixedAssetUsersHistoryData,
  assetHistoryFetching,
  handleRemoveData
}: AppProps) => {
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  const styleColor = (name: string) => {
    return {
      padding: "4px 12px",
      color: `${
        name === "Good"
          ? "#82b01f"
          : name === "Obsolete"
          ? "#dd4433"
          : name === "Missing"
          ? "#262a44"
          : name === "Bad"
          ? "#f3a119"
          : name === "Yet to Capitalize"
          ? "rgb(32, 128, 246)"
          : ""
      }`,
      background: `${
        name === "Good"
          ? "#e7f0d4"
          : name === "Obsolete"
          ? "#ffebe9"
          : name === "Missing"
          ? "#f4f6f8"
          : name === "Bad"
          ? "#faedd8"
          : name === "Yet to Capitalize"
          ? "rgb(227, 239, 255)"
          : ""
      }`,
      borderRadius: "16px",
    };
  };

  const handleEnableDisableClick = (data: any) => {
    handleConfirmationModal();
    handleDeleteData(data);
  };
  return (
    <>
      {finacAssetListing &&
        finacAssetListing?.length > 0 &&
        finacAssetListing?.map((data: any) => {
          return (
            <tr>
              {tableHeader &&
                tableHeader?.length > 0 &&
                tableHeader?.map((item: any) => {
                  if (item.value === "finac_asset_id") {
                    return (
                      <td className="text-start" style={{ width: "150px" }}>
                        <span>
                          {data?.finac_asset_id ? data?.finac_asset_id : "NA"}
                        </span>
                      </td>
                    );
                  } else if (item.value === "asset_id") {
                    return (
                      <td className="text-start" style={{ width: "80px" }}>
                        <span>{data?.asset_id ? data?.asset_id : "NA"}</span>
                      </td>
                    );
                  } 
                  else if (item.value === "is_assigned") {
                    return (
                      <td className="text-start" style={{ width: "80px" }}>
                        {data?.is_assigned === 1 ? (
                          <>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 0, hide: 0 }}
                              overlay={
                                // assetHistoryFetching ? (
                                //   <Tooltip id="button-view-filter-invoice">
                                //     <span>Loading...</span>
                                //   </Tooltip>
                                // ) : 
                                fixedAssetUsersHistoryData &&
                                  fixedAssetUsersHistoryData?.length > 0 ? (
                                  <Tooltip id="button-view-filter-invoice">
                                    <div
                                      className="ml-2"
                                      style={{
                                        display: "flex",
                                        justifyContent: "left",
                                        alignItems: "center",
                                        gap: "7px",
                                        height: "40px",
                                      }}
                                    >
                                      <CircularAvatar
                                        name={`${fixedAssetUsersHistoryData[0]?.first_name} ${fixedAssetUsersHistoryData[0]?.last_name}`}
                                        image={
                                          fixedAssetUsersHistoryData[0]?.profile_pic &&
                                          fixedAssetUsersHistoryData[0]?.profile_pic?.file_url
                                        }
                                      />
                                      <div>
                                        {`${fixedAssetUsersHistoryData[0]?.first_name} ${fixedAssetUsersHistoryData[0]?.last_name} `}
                                      </div>
                                    </div>
                                  </Tooltip>
                                ) : (
                                 <span></span>
                                )
                              }
                            >
                              <span
                                onMouseEnter={() => handleShowAssetUser(data)}
                                onMouseLeave={()=>handleRemoveData()}
                                style={{
                                  color:
                                    data?.is_assigned === 1 ? "#82b01f" : "#262a44",
                                  backgroundColor:
                                    data?.is_assigned === 1 ? "#e7f0d4" : "#f4f6f8",
                                  padding: "4px 12px",
                                  borderRadius: "16px",
                                }}
                              >
                                {data?.is_assigned === 1 ? "Yes" : "No"}
                              </span>
                            </OverlayTrigger>
                          </>
                        ) : (
                          <>
                            <span
                              style={{
                                color: data?.is_assigned === 1 ? "#82b01f" : "#262a44",
                                backgroundColor:
                                  data?.is_assigned === 1 ? "#e7f0d4" : "#f4f6f8",
                                padding: "4px 12px",
                                borderRadius: "16px",
                              }}
                            >
                              {data?.is_assigned === 1 ? "Yes" : "No"}
                            </span>
                          </>
                        )}
                      </td>
                    );
                  }
                  
                   else if (item.value === "condition") {
                    return (
                      <td
                        className="text-start"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span style={styleColor(data?.condition)}>
                          {data?.condition ? data?.condition : "NA"}
                        </span>
                      </td>
                    );
                  } else if (item.value === "asset_description") {
                    return (
                      <td className="text-start">
                        {!data?.asset_description
                          ? "NA"
                          : data?.asset_description}
                      </td>
                    );
                  } else if (item.value === "location") {
                    return <td>{data?.location ? data?.location : "NA"}</td>;
                  } else if (item.value === "department") {
                    return (
                      <td>
                        {data?.department_name ? data?.department_name : "NA"}
                      </td>
                    );
                  } else if (item.value === "attachment_count") {
                    return <td>{data?.uploads?.length}</td>;
                  } else if (item.value === "lAST UPDATED") {
                    return (
                      <td style={{ minWidth: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={data?.updated_by_details?.first_name}
                          lastName={data?.updated_by_details?.last_name}
                          profilePic={
                            data?.updated_by_details?.profile_pic?.file_url
                          }
                          updatedAt={formateDateTime(data?.updated_at)}
                        />
                      </td>
                    );
                  } else if (item.value === "LAST VERIFIED BY") {
                    return (
                      <td>
                        {data?.verify_by_details?.first_name?.length &&
                        `${data?.verify_by_details?.first_name} ${data?.verify_by_details?.last_name}`
                          ?.length > 15 ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {data?.verify_by_details?.first_name}{" "}
                                {data?.verify_by_details?.last_name}
                              </Tooltip>
                            }
                          >
                            <p
                              style={{
                                marginBottom: "0px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {data?.verify_by_details?.first_name?.length &&
                                `${data?.verify_by_details?.first_name} ${data?.verify_by_details?.last_name}`?.slice(
                                  0,
                                  15
                                )}
                              ...
                            </p>
                          </OverlayTrigger>
                        ) : (
                          <p
                            style={{
                              marginBottom: "0px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {data?.verify_by_details?.first_name?.length ? (
                              `${data?.verify_by_details?.first_name} ${data?.verify_by_details?.last_name}`?.slice(
                                0,
                                15
                              )
                            ) : (
                              <div
                                style={{
                                  paddingTop: data?.verify_by_details
                                    ?.first_name?.length
                                    ? "14px"
                                    : "",
                                }}
                              >
                                NA
                              </div>
                            )}
                          </p>
                        )}
                        <p
                          className="due-date-text"
                          style={{
                            marginBottom: data?.verify_at ? "5px" : "0px",
                            marginTop: data?.verify_at ? "5px" : "0px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {data?.verify_at
                            ? formateDateTime(data?.verify_at)
                            : ""}
                        </p>
                      </td>
                    );
                  } else if (item.value === "QR CODE IMAGE") {
                    return (
                      <td>
                        {data?.qr_code ? (
                          <div>
                            <PDFDownloadLink
                              document={
                                <MadePdf
                                  qrCode={
                                    data?.qr_code
                                      ? `${blobBaseUrl}${data?.qr_code}?${blobToken}`
                                      : ""
                                  }
                                  logo={
                                    data?.logo_details?.file_url
                                      ? `${blobBaseUrl}${data?.logo_details?.file_url}?${blobToken}`
                                      : "true"
                                  }
                                  text={data?.finac_asset_id}
                                  category={data?.asset_category}
                                  description={data?.asset_description}
                                  assetId={data?.asset_id}
                                  subLocation={data?.sub_location}
                                  department={data?.department_name}
                                  glCode={data?.gl_code}
                                />
                              }
                              fileName={`${data?.finac_asset_id}.pdf`}
                            >
                              <button
                                style={{
                                  padding: 0,
                                  border: "none",
                                }}
                                onClick={() => {
                                  // url && window.open(url, "_blank");
                                }}
                              >
                                {data?.qr_code && (
                                  <img
                                    src={`${blobBaseUrl}${data?.qr_code}?${blobToken}`}
                                    alt=""
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                    }}
                                  />
                                )}
                                <p style={{ background: "white", margin: 0 }}>
                                  {data?.finac_asset_id}
                                </p>
                              </button>
                            </PDFDownloadLink>
                          </div>
                        ) : (
                          "NA"
                        )}
                      </td>
                    );
                  } else if (data[item.value]) {
                    return <td className="text-start"> {data[item.value]}</td>;
                  } else if (item.value === "action") {
                    return (
                      <td
                        style={{
                          textAlign: "start",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            gap: "5%",
                          }}
                        >
                          {isEditFixedAssetPresent && (
                            <span
                              className="d-inline-block pointer"
                              onClick={() => {
                                history?.push({
                                  pathname: `/fixed-asset-register/fixed-asset-register-list/${clientCode}/edit/${data?.finac_asset_id}`,
                                  state: {
                                    client_code: clientCode,
                                    company_name,
                                    id: data?.finac_asset_id,
                                    persistData,
                                  },
                                });
                              }}
                            >
                              <div
                                style={{
                                  color: "#d43",
                                  fontSize: 20,
                                  // width: "50px",
                                }}
                              >
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 250 }}
                                  overlay={
                                    <Tooltip id="button-view-open-item">
                                      Edit
                                    </Tooltip>
                                  }
                                >
                                  <img src={tableEditIcon} alt="" />
                                </OverlayTrigger>
                              </div>
                            </span>
                          )}
                          <span
                            className="pointer"
                            onClick={() => handleHistoryFixedAssetModule(data)}
                          >
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                  <Tooltip id="button-view-open-item">
                                    Audit History
                                  </Tooltip>
                                }
                              >
                                <img src={FARHistoryIcon} alt="" />
                              </OverlayTrigger>
                            </div>
                          </span>
                          {isDeleteFixedAssetPresent && (
                            <span
                              className="d-inline-block pointer"
                              onClick={() => {
                                handleEnableDisableClick(data?.finac_asset_id);
                              }}
                            >
                              <div
                                style={{
                                  color: "#d43",
                                  fontSize: 20,
                                  // width: "50px",
                                }}
                              >
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 250 }}
                                  overlay={
                                    <Tooltip id="button-view-open-item">
                                      Delete
                                    </Tooltip>
                                  }
                                >
                                  <img src={deleteIcon} alt="" />
                                </OverlayTrigger>
                              </div>
                            </span>
                          )}
                        </div>
                      </td>
                    );
                  } else {
                    return <td className="text-start"> NA </td>;
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default FixedAssetTableData;
